'use client';

import { useUserData } from '@/context/auth/user-data-context';
import { ContentType } from '@/graphql/graphql';
import { useTranslations } from 'next-intl';
import { CategoriesDropDown } from '../catagories-dropdown';
import { CatalogDropDown } from '../catalog-dropdown';
import { GuestDropDown } from '../guest-dropdown';
import NavigationLink from '../navigation-link';
import { useController } from './controller';
import { NavigationProps } from './interfaces';

export const Navigation = ({ onLinkClickAction }: NavigationProps) => {
    const t = useTranslations('Navigation');
    const th = useTranslations('Header');
    const { isBuyer, isSeller, loading } = useUserData();

    const { categoriesProgram, categoriesFormat, isLinkActive } = useController({
        translateNavigation: t as (key: string) => string,
    });

    if (loading) {
        return (
            <nav className="text-content-on-dark transition-all duration-300 flex flex-col max-lg:gap-2 lg:flex-row lg:items-center lg:space-x-6" />
        );
    }

    const showGuestMenu = !isSeller && !isBuyer;
    return (
        <nav className="text-content-on-dark transition-all duration-300 flex flex-col max-lg:gap-2 lg:flex-row lg:items-center lg:space-x-6">
            {showGuestMenu ? (
                <GuestDropDown
                    isActive={isLinkActive('/tv-rights-buyers') || isLinkActive('/tv-rights-sellers')}
                    onLinkClickAction={onLinkClickAction}
                />
            ) : null}
            {isBuyer || showGuestMenu ? (
                <>
                    <CategoriesDropDown
                        isActive={isLinkActive('/programs')}
                        contentType={ContentType.Program}
                        categories={categoriesProgram}
                        onLinkClickAction={onLinkClickAction}
                    />
                    <CategoriesDropDown
                        isActive={isLinkActive('/formats')}
                        contentType={ContentType.Format}
                        categories={categoriesFormat}
                        onLinkClickAction={onLinkClickAction}
                    />
                </>
            ) : null}
            {isSeller ? (
                <>
                    <NavigationLink href="/dashboard" isActive={isLinkActive('/dashboard')} onClick={onLinkClickAction}>
                        {t('seller.dashboard')}
                    </NavigationLink>
                    <CatalogDropDown callback={() => !!onLinkClickAction && onLinkClickAction()} />
                </>
            ) : null}
            {isSeller || isBuyer ? (
                <NavigationLink href="/licenses" isActive={isLinkActive('/licenses')} onClick={onLinkClickAction}>
                    {t('licenses')}
                </NavigationLink>
            ) : null}
            {isBuyer ? (
                <div className="lg:hidden">
                    <NavigationLink
                        href="/transactions"
                        isActive={isLinkActive('/transactions')}
                        onClick={onLinkClickAction}
                    >
                        {t('buyer.transactions')}
                    </NavigationLink>
                </div>
            ) : null}
            {isBuyer || isSeller ? (
                <div className="lg:hidden">
                    <NavigationLink
                        href="/account"
                        isActive={isLinkActive('/account', 'inclusive')}
                        onClick={onLinkClickAction}
                    >
                        {th('accountSettings')}
                    </NavigationLink>
                </div>
            ) : null}
            {isBuyer ? (
                <div className="lg:hidden">
                    <NavigationLink
                        href="/settings"
                        isActive={isLinkActive('/settings', 'inclusive')}
                        onClick={onLinkClickAction}
                    >
                        {th('technicalSettings')}
                    </NavigationLink>
                </div>
            ) : null}
        </nav>
    );
};
